import { Col } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { DonationFailedReason } from 'gql/types';
import {
  ControlledInputNumber,
  ControlledSelect,
} from 'modules/common/components';
import { FormFieldWithComponent } from 'modules/common/types';
import ControlledDonationUnitRadioGroup from 'modules/donations/components/DonationUnitRadioGroup';
import { getTranslation } from 'utils/getTranslation';

import { QuantityFields } from './enum';

const t = getTranslation('donation.CreateDonationForm.Quantity');

const optionsLabels: Record<DonationFailedReason, string> = {
  [DonationFailedReason.Medical]: t('medical'),
  [DonationFailedReason.Phlebotomy]: t('phlebotomy'),
  [DonationFailedReason.Restraint]: t('restraint'),
};

const failedReasonOptions: DefaultOptionType[] = Object.values(
  DonationFailedReason
).map<DefaultOptionType>((reason) => {
  return {
    label: optionsLabels[reason],
    value: reason,
  };
});

export type QuantityFormFiledType = FormFieldWithComponent<
  QuantityFields,
  { name: string }
>;

type Props = {
  enabled: boolean;
};

export const getQuantityFields = ({
  enabled,
}: Props): QuantityFormFiledType[] => [
  {
    name: QuantityFields.approvedDonationsMl,
    label: t('Approved donation amount, ML'),
    Component: ({ control, name }) => {
      return (
        <Col span={24}>
          <ControlledInputNumber
            disabled={true}
            controlled={{ control, name }}
            placeholder={t('enterExpected')}
            addonAfter={t('ml')}
            stringMode
          />
        </Col>
      );
    },
  },
  {
    name: QuantityFields.unit,
    Component: ({ control, name }) => (
      <ControlledDonationUnitRadioGroup
        disabled={!enabled}
        controlled={{ control, name }}
      />
    ),
  },
  {
    name: QuantityFields.actual,
    label: t('actual'),
    Component: ({ control, name }) => (
      <Col span={24}>
        <ControlledInputNumber
          disabled={!enabled}
          controlled={{ control, name }}
          placeholder={t('enterActual')}
          addonAfter={t('ml')}
        />
      </Col>
    ),
  },
  {
    name: QuantityFields.failedReason,
    label: t('failedReason'),
    Component: ({ control, name }) => (
      <Col span={24}>
        <ControlledSelect
          options={failedReasonOptions}
          disabled={!enabled}
          controlled={{ control, name }}
          placeholder={t('selectFailedReason')}
        />
      </Col>
    ),
  },
];
